import React from 'react';
import './about.css';
import '../../assets/about.jpg'
import CV from '../../assets/cv.pdf';
import { TbAward, TbBriefcase} from 'react-icons/tb';

const About = () => {
  return (
    <section className='about section' id='about'>
        <h2 className='section__title'> About Me</h2>
        <h3 className='section__subtitle'>Personal Summary</h3>
        <div className='about__container container grid'>
            <img src={require('../../assets/about.jpg')} alt='Profile' title='Profile' className='about__img'/>
            <div className='about__data'>
                <div className='about__info grid'>
                    <div className='about__box'>
                        <TbAward className='about__icon'/>
                        <h3 className='about__title'>Experience</h3>
                        <span className='about__subtitle'>5 Years Working</span>
                    </div>
                    <div className='about__box'>
                        <TbBriefcase className='about__icon'/>
                        <h3 className='about__title'>Completed</h3>
                        <span className='about__subtitle'>45+ Projects</span>
                    </div>
                   
                </div>
                <p className='about__description'>
                I'm a passionate front-end developer with over 5 years of experience specializing in building scalable, high-performance web applications using React.js and TypeScript. I focus on crafting responsive, accessible user interfaces with a keen attention to detail, ensuring cross-browser compatibility and mobile-first designs.
Throughout my career, I’ve optimized application performance by writing efficient, reusable, and maintainable code, while integrating and consuming REST APIs for seamless data handling and state management. I thrive in Agile environments, collaborating closely with cross-functional teams and managing tasks through tools like Jira.

                </p>
            
            </div>
        </div>
    </section>
  )
}

export default About